package xyz.malefic.kanman.client.components.layouts

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.aspectRatio
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.common.DisabledStyle
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import xyz.malefic.kanman.client.api.getUser
import xyz.malefic.kanman.client.api.util.AuthSession
import xyz.malefic.kanman.client.api.util.Request
import xyz.malefic.kanman.client.components.ErrorOverlay
import xyz.malefic.kanman.client.components.UserSettingsOverlay
import xyz.malefic.kanman.client.styles.Color

@Layout
@Composable
fun NavBarLayout(
    ctx: PageContext,
    content: @Composable () -> Unit,
) {
    val currentRoute = ctx.route.path
    var showUserSettings by remember { mutableStateOf(false) }

    Row(Modifier.fillMaxSize().height(100.vh)) {
        Surface(Modifier.fillMaxHeight().backgroundColor(Color.surfaceContainerHigh)) {
            Column(Modifier.fillMaxSize().padding(16.px), horizontalAlignment = Alignment.CenterHorizontally) {
                H1(Modifier.margin(16.px).toAttrs()) { Text("KanMan") }

                Column(verticalArrangement = Arrangement.spacedBy(24.px), horizontalAlignment = Alignment.CenterHorizontally) {
                    Pages.entries.forEach { page ->
                        if (page.hasRoute(currentRoute)) {
                            SpanText(page.value, DisabledStyle.toModifier())
                        } else {
                            Link(page.route) { Text(page.value) }
                        }
                    }
                }

                if (AuthSession.accessToken != null) {
                    Request(Unit, request = { getUser() }) { user ->
                        Spacer()
                        Row(
                            Modifier
                                .padding(16.px)
                                .backgroundColor(Color.secondaryContainer)
                                .borderRadius(16.px)
                                .cursor(Cursor.Pointer)
                                .onClick { showUserSettings = true },
                            verticalAlignment = Alignment.CenterVertically,
                        ) {
                            Image(user.profilePicture, "${user.username}'s profile picture", Modifier.size(48.px).aspectRatio(1))
                            Column(
                                Modifier.padding(left = 16.px),
                                Arrangement.spacedBy(12.px),
                                Alignment.CenterHorizontally,
                            ) {
                                P { Text(user.username) }
                                Link("/logout") { Text("Log Out") }
                            }
                        }

                        if (showUserSettings) {
                            UserSettingsOverlay(user, onClose = { showUserSettings = false })
                        }
                    }
                }
            }
        }

        Box(Modifier.fillMaxSize().weight(1).overflow(Overflow.Auto)) {
            content()
        }

        ErrorOverlay(ctx)
    }
}

enum class Pages(
    val value: String,
    val route: String,
) {
    INDEX("Home", "/"),
    DRIVE("Your Boards", "/boards/drive"),
    PUBLIC("Public Boards", "/boards/public"),
    ABOUT("About", "/about"),
    ;

    fun hasRoute(route: String): Boolean = route.trimEnd('/') == this@Pages.route.trimEnd('/')
}
